import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './locales/es.json';
import en from './locales/en.json';
import ru from './locales/ru.json';
import fr from './locales/fr.json';

// Idiomas soportados por la plataforma (coincide con columnas _es/_en/_ru/_fr de Supabase).
export const SUPPORTED_LANGS = ['es', 'en', 'ru', 'fr'];

// Migración suave: el selector previo guardaba 'ES', 'EN' (mayúsculas) en idy_lang.
// i18next-browser-languagedetector espera códigos ISO en minúsculas.
// Si al arrancar detectamos un valor mayúsculo legado, lo normalizamos.
try {
  const legacy = localStorage.getItem('idy_lang');
  if (legacy && legacy !== legacy.toLowerCase()) {
    localStorage.setItem('idy_lang', legacy.toLowerCase());
  }
} catch {
  /* SSR / modo incógnito bloqueado */
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      ru: { translation: ru },
      fr: { translation: fr },
    },
    fallbackLng: 'es',
    supportedLngs: SUPPORTED_LANGS,
    nonExplicitSupportedLngs: true, // 'es-ES' → 'es', 'en-US' → 'en', etc.
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'idy_lang',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // React ya escapa
    },
    react: {
      useSuspense: false, // recursos embebidos, no hace falta Suspense para carga async
    },
  });

export default i18n;
